import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

import { RdsChip } from '../chips/index';
import { RDS_NUMERIC_OPERATION_OPTIONS, RdsNumericFilter, RdsNumericOperationOption } from './numeric-filter.model';

@Component({
  selector: 'rds-numeric-filter',
  templateUrl: './numeric-filter.component.html',
  styleUrls: ['./numeric-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RdsNumericFilterComponent implements OnChanges {
  /** Numeric Filters */
  @Input() filters: Array<RdsNumericFilter>;

  /** Whether to use the large chip style variant */
  @HostBinding('class.large-chips')
  @Input()
  largeChips = false;

  /** Event emitted when the user adds new filter */
  @Output() add = new EventEmitter<RdsNumericFilter>();
  /** Event emitted when the user removes a filter */
  @Output() remove = new EventEmitter<RdsNumericFilter>();

  /* operators */
  enabledOptions: { [operation: string]: boolean } = { '>': true, '>=': true, '=': true, '!=': true, '<': true, '<=': true };

  /* Operation label and type */
  allOptions: ReadonlyArray<RdsNumericOperationOption> = RDS_NUMERIC_OPERATION_OPTIONS;

  /* Added filter operation and value from inputs */
  newValue = new RdsNumericFilter(null, null);

  constructor(private cdr: ChangeDetectorRef) {}

  /**
   * Emit added values and clear the inputs
   */
  handleAdd(newValue) {
    this.add.emit(newValue);
    this.newValue = new RdsNumericFilter(null, null);
  }

  handleRemove(chip: RdsChip) {
    const found = this.filters.find((f) => f.operation.type + f.value === chip.id);
    this.remove.emit(found);
  }

  /**
   * Any time the filters change, determine which operations are still applicable, if any
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.filters) {
      this.enabledOptions = { '>': true, '>=': true, '=': true, '!=': true, '<': true, '<=': true };
      for (const f of changes.filters.currentValue) {
        switch (f.operation.type) {
          case '>':
          case '>=':
            this.enabledOptions['>'] = false;
            this.enabledOptions['>='] = false;
            break;
          // case '=':
          //   this.enabledOptions['!='] = false;
          //   this.enabledOptions['>'] = false;
          //   this.enabledOptions['>='] = false;
          //   this.enabledOptions['<'] = false;
          //   this.enabledOptions['<='] = false;
          //   break;
          // case '!=':
          //   this.enabledOptions['='] = false;
          //   this.enabledOptions['>'] = false;
          //   this.enabledOptions['>='] = false;
          //   this.enabledOptions['<'] = false;
          //   this.enabledOptions['<='] = false;
          //   break;
          case '<':
          case '<=':
            this.enabledOptions['<'] = false;
            this.enabledOptions['<='] = false;
            break;
        }
      }
      this.cdr.markForCheck();
    }
  }
}
